/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useCallback, useEffect, useState } from 'react';
import { Cross, DownTriangleSmall, UpTriangleSmall } from 'sushiweb/Icons';
import { white } from 'sushiweb/tokens/color';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';

const SelectedValueList = ({ dropDownvalues, deSelectOption }) => {
  return (
    <>
      {dropDownvalues.map((option, index) => {
        return (
          <span
            className='tw-flex tw-gap-4 tw-py-2 tw-px-3 tw-bg-green-700 tw-text-base-white tw-rounded-full  tw-h-11 tw-min-w-fit tw-flex-wrap'
            key={`${option.name}_${index}`}
          >
            <span className='tw-text-200 tw-font-medium'>{option?.name}</span>
            <span className='tw-border tw-border-solid tw-border-[#cfcfcf] tw-rounded-full'>
              <Cross
                color={white}
                size={16}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  deSelectOption(option, e);
                }}
              />
            </span>
          </span>
        );
      })}
    </>
  );
};

export default function Select({
  field,
  inputKey,
  selectOptions,
  saveOptions,
  unSaveOptions,
  defaultValue = null,
  errors = null,
  isMultiSelect = false,
  disabled = false,
  clearInputs = false,
  UparrowIcon = <UpTriangleSmall />,
  DownarrowIcon = <DownTriangleSmall />,
}) {
  const [dropDownvalues, setDropdownValues] = useState([]);
  const [singleSelectionValue, setSingleSelectionValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    if (!isMultiSelect && defaultValue && !Array.isArray(defaultValue)) {
      setSingleSelectionValue(defaultValue);
      return;
    }

    if (defaultValue?.length) setDropdownValues([...defaultValue]);
  }, [defaultValue]);

  useEffect(() => {
    if (clearInputs) {
      setSingleSelectionValue(null);
      setDropdownValues([]);
    }
  }, [clearInputs]);

  const handleDropdown = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDropdown((prevState) => !prevState);
  }, []);

  const singleSelection = useCallback(
    (value, valueToShow, event) => {
      setSingleSelectionValue(valueToShow || '');
      saveOptions(inputKey, value);
      handleDropdown(event);
    },
    [handleDropdown, inputKey, saveOptions],
  );

  const selectOption = useCallback(
    (value, valueToShow, event) => {
      if (!dropDownvalues.some((opt) => opt?.id === value)) {
        let newDropdownValues = [...dropDownvalues];
        newDropdownValues.push({ id: value, name: valueToShow });
        setDropdownValues(newDropdownValues);
      }
      saveOptions(inputKey, value);
      if (!isMultiSelect) handleDropdown(event);
    },
    [dropDownvalues, saveOptions, inputKey, isMultiSelect, handleDropdown],
  );

  const deSelectOption = useCallback(
    (option, event) => {
      let newDropdownValues = [...dropDownvalues];
      const ind = newDropdownValues.indexOf(option);
      newDropdownValues.splice(ind, 1);
      const value = option.id;
      unSaveOptions(inputKey, value);
      setDropdownValues(newDropdownValues);
    },
    [dropDownvalues, handleDropdown, inputKey, unSaveOptions],
  );

  return (
    <div
      className={`tw-flex-col tw-w-full tw-relative ${
        disabled ? 'tw-cursor-not-allowed' : ''
      }`}
      css={`
        div {
          width: 100%;
        },
      `}
    >
      <div
        type='text'
        placeholder={field?.placeholder}
        className={`tw-px-5 tw-py-2 tw-border-solid tw-border-grey-300 tw-border-[0.5px] tw-rounded-lg tw-bg-base-white/[0.24] tw-flex tw-items-center  tw-justify-center tw-cursor-pointer
       ${
         errors?.old_email?.message
           ? 'focus:tw-ring-[#BF2938] focus:tw-border-red-500'
           : 'focus:tw-ring-green-500 focus:tw-border-green-500'
       } ${
          disabled ? 'tw-pointer-events-none' : ''
        } tw-border-solid tw-border-grey-300 tw-border-[0.5px]`}
        onClick={(e) => {
          handleDropdown(e);
        }}
        css={`
          min-height: 4rem !important;
        `}
      >
        <div className='tw-flex tw-gap-4'>
          {isMultiSelect && showDropdown && dropDownvalues?.length ? (
            <SelectedValueList
              dropDownvalues={dropDownvalues}
              deSelectOption={deSelectOption}
            />
          ) : singleSelectionValue ? (
            <span className='tw-text-300 tw-text-grey-800 tw-font-medium'>
              {singleSelectionValue}
            </span>
          ) : (
            <span className='tw-text-300 tw-text-grey-800 tw-font-medium '>
              {field?.placeholder || 'Select Option'}
            </span>
          )}
        </div>
      </div>
      <span
        className={`tw-absolute tw-right-4 tw-top-4 ${
          disabled ? 'tw-pointer-events-none' : ''
        }`}
        onClick={(e) => {
          handleDropdown(e);
        }}
      >
        {showDropdown ? UparrowIcon : DownarrowIcon}
      </span>
      {showDropdown && (
        <OnClickOutside
          handleClickOutside={(e) => {
            handleDropdown(e);
          }}
          width='100%'
        >
          <div
            className=' tw-absolute tw-top-[45px] tw-z-50 tw-flex-col tw-rounded-xl tw-bg-base-white  tw-max-h-[20rem] tw-overflow-y-auto'
            css={`
              box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);
            `}
          >
            <>
              {selectOptions.map((option, index) => {
                return (
                  <div
                    className={`tw-text-300 tw-font-medium tw-cursor-pointer tw-px-6 tw-py-2 hover:tw-bg-grey-200 ${
                      dropDownvalues.some((opt) => opt?.id === option?.id)
                        ? 'tw-text-green-700'
                        : 'tw-text-grey-700'
                    } tw-border-[0.1rem] tw-border-solid tw-border-grey-200 tw-border-t-0 tw-border-x-0`}
                    onClick={(e) => {
                      if (isMultiSelect)
                        selectOption(option?.id, option?.name, e);
                      else singleSelection(option?.id, option?.name, e);
                    }}
                    key={`${option.id}_${index}`}
                  >
                    {option?.name}
                  </div>
                );
              })}
            </>
          </div>
        </OnClickOutside>
      )}
      {isMultiSelect && dropDownvalues?.length ? (
        <div className='tw-flex tw-w-full tw-gap-1 tw-flex-wrap tw-mt-3'>
          <SelectedValueList
            dropDownvalues={dropDownvalues}
            deSelectOption={deSelectOption}
          />
        </div>
      ) : null}
    </div>
  );
}
